export const CapitalizeName=(name)=>{
    return name? name.charAt(0).toUpperCase()+name.slice(1):''
}